export default {
  classColors: {
    Multimercado: '#374459',
    Internacional: '#2e86ab',
    'Renda Variável': '#2fb89f',
    'RF Pós-Fixado': '#645e9d',
    'RF Inflação': '#e75735',
    'RF Pré-Fixado': '#f29741',
    'RF IGP-M': '#ffbb00',
    COE: '#6c757d',
    'Fundo de Previdência': '#6E1100',
    Caixa: '#6c757d',
  },
  banksColors: {
    xp: '#644D40',
    bb: '#2D6727',
    itau: '#FF8F00',
    santander: '#6C757D',
    bradesco: '#65CB3B',
    btg: '#FFBB00',
    safra: '#AAABE2',
    genial: '#F29741',
  },
  escritorio: {
    nome: PARAMETROS.escritorio.nome,
    id_escritorio: PARAMETROS.escritorio.id_escritorio,
  },
  colors: {
    primary: '',
    accent: '',
    mode: 'light_mode',
    paleta: [
      '#374459',
      '#2E86AB',
      '#6E1100',
      '#E75735',
      '#986F4B',
      '#2FB89F',
      '#645E9D',
      '#7FB97F',
      '#F6E89F',
      '#644D40',
      '#2D6727',
      '#FF8F00',
      '#6C757D',
      '#65CB3B',
      '#FFBB00',
      '#AAABE2',
      '#F29741',
    ],
    light_mode: {
      red: '#FF5252',
      yellow: '#FFD500',
      green: '#00E988',
      white: '#FFFFFF',
      black: '#000000',
      blue: '#3242B9',
      'green-light': '#C8E6C9',
      'red-light': '#FFCDD2',
      'yellow-light': '#FFF9C4',
      'gray-1': '#F0F1F5',
      'gray-2': '#F1EFF2',
      'gray-3': '#E4E0E6',
      'gray-4': '#C7BBC9',
      'gray-5': '#A79CAC',
      'gray-6': '#87798D',
      'gray-7': '#38303B',
      'gray-8': '#2D212F',
      primary: '#3242B9',
      'primary-light': '#616ed4',
      'primary-dark': '#2d3ba5',
      secondary: '#C7BBC9',
      success: '#00E988',
      danger: '#FF5252',
      light: '#F0F1F5',
      dark: '#2D212F',
      warning: '#FFD500',
      'v-anchor-base': '#3242b9',
      'v-primary-base': '#3242b9',
    },
  },
  logo:
      'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/offices/3/logo.png',
  favicon:
      'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/offices/3/favicon.png',
  backgroundImage:
      'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/offices/3/bg-login.png',
}
